import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ITenantState, TENANT_STORE_KEY } from './tenant-store.state';

const state = createFeatureSelector<ITenantState>(TENANT_STORE_KEY);

export const tenants = createSelector(state, (state1: ITenantState) => state1.tenants);
export const currentTenant = createSelector(state, (state1: ITenantState) => state1.currentTenant);
export const globalTenant = createSelector(state, (state1: ITenantState) => state1.isGlobalTenant);
